import { Box, Drawer } from "@mui/material";
import React, { useState } from "react";

function RightDrawer({ actionButton, width = "30", children }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };
  return (
    <>
      <div
        onClick={(event) => {
          event.stopPropagation();
          toggleDrawer(true)(event);
        }}
      >
        {actionButton}
      </div>
      <Drawer open={isOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: `${width}rem` }}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          <div className="w-full">{children}</div>
        </Box>
      </Drawer>
    </>
  );
}

export default RightDrawer;
